/** Keep in sync with backend/src/utils/cancellationPolicy.js */
export const CANCELLATION_CUTOFF_HOURS = 3;

const CANCELLATION_CUTOFF_MS = CANCELLATION_CUTOFF_HOURS * 60 * 60 * 1000;

export const getCancellationStatus = (activityDate) => {
  const start = new Date(activityDate).getTime();
  if (Number.isNaN(start)) {
    return { allowed: false, hoursLeft: null, reason: 'past' };
  }

  const msUntilStart = start - Date.now();
  if (msUntilStart <= 0) {
    return { allowed: false, hoursLeft: 0, reason: 'past' };
  }
  if (msUntilStart < CANCELLATION_CUTOFF_MS) {
    return {
      allowed: false,
      hoursLeft: Math.max(0, msUntilStart / (60 * 60 * 1000)),
      reason: 'cutoff',
    };
  }

  return {
    allowed: true,
    hoursLeft: msUntilStart / (60 * 60 * 1000),
    reason: null,
  };
};

export const canCancelRegistration = (activityOrDate) => {
  const date = activityOrDate?.date ?? activityOrDate;
  return getCancellationStatus(date).allowed;
};

export const cancellationCutoffMessage = (activityOrDate) => {
  const date = activityOrDate?.date ?? activityOrDate;
  const status = getCancellationStatus(date);
  if (status.reason === 'past') {
    return 'Cette activité a déjà commencé ou est terminée.';
  }
  if (status.reason === 'cutoff') {
    return `Les annulations sont fermées moins de ${CANCELLATION_CUTOFF_HOURS} heures avant le début du cours.`;
  }
  return '';
};
